var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatecomment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_961_37182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 40.5,
    r: 22.5,
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4836 44.7668C56.1168 45.095 54.6898 45.0791 53.3306 44.7205C51.9714 44.3619 50.7223 43.6718 49.6953 42.7121C48.6682 41.7523 47.8952 40.5528 47.4455 39.2209C46.9958 37.8891 46.8834 36.4665 47.1184 35.0806C47.0826 35.1151 47.0449 35.1475 47.0054 35.1776C46.7254 35.3906 46.3754 35.4696 45.6753 35.6276L45.0403 35.7716C42.5803 36.3286 41.3502 36.6066 41.0572 37.5476C40.7652 38.4876 41.6032 39.4687 43.2803 41.4297L43.7143 41.9367C44.1903 42.4937 44.4293 42.7727 44.5363 43.1168C44.6433 43.4618 44.6073 43.8338 44.5353 44.5768L44.4693 45.2538C44.2163 47.8709 44.0893 49.1789 44.8553 49.7599C45.6213 50.3419 46.7734 49.8119 49.0754 48.7509L49.6724 48.4769C50.3265 48.1749 50.6535 48.0249 51.0005 48.0249C51.3475 48.0249 51.6745 48.1749 52.3295 48.4769L52.9245 48.7509C55.2276 49.8109 56.3796 50.3409 57.1446 49.7609C57.9116 49.1789 57.7846 47.8709 57.5316 45.2538L57.4836 44.7668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1537 33.4081L47.8257 33.9961C47.4657 34.6421 47.2857 34.9651 47.0057 35.1781C47.0457 35.1481 47.0827 35.1161 47.1187 35.0811C46.8836 36.4672 46.996 37.8899 47.4458 39.2218C47.8955 40.5537 48.6686 41.7533 49.6958 42.7131C50.723 43.673 51.9722 44.363 53.3316 44.7215C54.6909 45.08 56.118 45.0958 57.4849 44.7673L57.4649 44.5773C57.3939 43.8343 57.3579 43.4623 57.4649 43.1173C57.5719 42.7733 57.8099 42.4943 58.2869 41.9373L58.721 41.4303C60.398 39.4702 61.236 38.4892 60.943 37.5482C60.651 36.6072 59.421 36.3281 56.9609 35.7721L56.3249 35.6281C55.6259 35.4701 55.2759 35.3911 54.9949 35.1781C54.7149 34.9651 54.5349 34.6421 54.1748 33.9961L53.8478 33.4081C52.5808 31.136 51.9478 30 51.0008 30C50.0537 30 49.4207 31.136 48.1537 33.4081Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_961_37182",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.647059 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_961_37182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_961_37182",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatecomment);
export default __webpack_public_path__ + "static/media/ratecomment.47cfddf93b84b1127cc4f1769d9330b3.svg";
export { ForwardRef as ReactComponent };